import { render, staticRenderFns } from "./IndividualJ.vue?vue&type=template&id=95f07c0a&scoped=true"
import script from "./IndividualJ.vue?vue&type=script&lang=js"
export * from "./IndividualJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f07c0a",
  null
  
)

export default component.exports